import React from 'react';

import Loading from 'components/Loading';
import { SpinnerContainer } from './Loader.syle';

const Loader = () => (
  <SpinnerContainer>
    <Loading size={80} color="#aaa" ariaLabel="Loading annotation sets" />
  </SpinnerContainer>
);

export default Loader;
